<template>
  <div>
    <form ref="careerDetails" class="career-details" @submit.prevent="save">
      <div class="row mt-2">
        <div class="col-md-6">
          <div class="form-group">
            <label for="cpost_title">Job Title: <span class="required-indicator">*</span></label>
            <input
              ref="cpostTitle"
              v-model="selected.post_title"
              :disabled="loadingEditor"
              id="cpost_title"
              name="cpost_title"
              type="text"
              required
              class="form-control w-100"
              autocomplete="off">
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label for="clocation">Location: <span class="required-indicator">*</span></label>
            <input
              ref="clocation"
              v-model="selected.location"
              :disabled="loadingEditor"
              id="clocation"
              name="clocation"
              type="text"
              required
              maxlength="255"
              class="form-control w-100"
              autocomplete="off">
          </div>
        </div>
      </div>
      <div class="row mt-2">
        <div class="col-md-6">
          <div class="form-group">
            <label for="cjob_type">Job Type: <span class="required-indicator">*</span></label>
            <select
              ref="cjobType"
              v-model="selected.job_type"
              :disabled="loadingEditor"
              class="form-control w-100"
              name="cjob_type"
              required>
              <option
                v-for="(type, index) in jobTypes"
                :key="`${type}-${index}`"
                :value="type.value"
                :label="type.label">{{ type.label }}</option>
            </select>
          </div>
        </div>
      </div>
      <div class="row mt-2">
        <div class="col-md-12">
          <div class="form-group" style="min-height: 600px;">
            <label>Content: <span class="required-indicator">*</span></label>
            <div>
              <template v-if="loadingEditor">
                <div class="progress" style="width: 100% !important">
                  <div
                    class="progress-bar progress-bar-striped progress-bar-animated"
                    role="progressbar"
                    aria-valuenow="100"
                    aria-valuemin="0"
                    aria-valuemax="100"
                    style="width: 100%"></div>
                </div>
              </template>
              <template v-else>
                <editor
                  ref="postContent"
                  v-model="selected.post_content"
                  api-key="pl6x3z60hczh55voaiqnr46bv5a5oqdg35w8ped317eeqibb"
                  :init="{
                    height: 600,
                    plugins: 'code lists',
                    toolbar: 'undo redo | styleselect | bold italic | alignleft aligncenter alignright alignjustify | outdent indent | numlist bullist'
                  }">
                </editor>
              </template>
            </div>
          </div>
        </div>
      </div>
    </form>
    <div class="row mt-2">
      <div class="col-md-12">
        <div class="button-group float-right">
          <template>
            <button
              :disabled="saveButton.saving || loadingEditor"
              class="btn btn-black"
              @click.prevent="handleClose">Cancel</button>
            <button
              :disabled="saveButton.saving || loadingEditor"
              class="btn btn-black"
              @click.prevent="save">
              <span
                v-if="saveButton.saving"
                class="fa fa-spinner fa-pulse">&nbsp;</span>
              {{ saveButton.text }}
            </button>
          </template>
        </div>
        <div class="clear-fix"></div>
      </div>
    </div>
  </div>
</template>

<script>
import Editor from '@tinymce/tinymce-vue'
import { Careers } from '../../../../api/careers'
export default {
  name: 'ManageCareer',
  components: { Editor },
  data() {
    return {
      selected: {
        post_title: '',
        location: '',
        job_type: '',
        post_content: ''
      },
      loadingEditor: true,
      isSettingSubmitting: false,
      saveButton: {
        text: 'Save',
        saving: false
      },
      jobTypes: [
        {
          label: 'Full Time',
          value: 'Full Time'
        },
        {
          label: 'Temporary',
          value: 'Temporary'
        },
        {
          label: 'Part Time',
          value: 'Part Time'
        },
        {
          label: 'Freelance',
          value: 'Freelance'
        },
        {
          label: 'Internship',
          value: 'Internship'
        }
      ],
      isNew: false
    }
  },
  beforeMount() {
    this.getCareer()
  },
  methods: {
    resetSaveButton() {
      this.saveButton.saving = false
      this.saveButton.text = 'Save'
    },
    handleClose() {
      this.$router.push({ path: '/careers' })
    },
    getCareer() {
      this.loadingEditor = true
      Careers({ id: this.$route.params.id }, 'get').then(response => {
        if (response.data.career) {
          this.selected = response.data.career
        }
        this.loadingEditor = false
      }).catch(() => {
        this.loadingEditor = false
      })
    },
    save() {
      if ( !this.checkData() ) return false
      this.saveButton.saving = true
      this.saveButton.text = 'Saving'
      const method = this.selected.ID ? 'put' : 'post'
      Careers(this.selected, method).then(() => {
        this.handleClose()
        this.resetSaveButton()
      }).catch(() => {
        this.resetSaveButton()
      })
    },
    checkData() {
      let hasEmpty = false,
        firstEl = false;
      const refss = ['cpostTitle', 'clocation', 'cjobType']
      const length = refss.length
      for (let i = 0; i <= length - 1; i++) {
        const el = this.$refs[refss[i]]
        if (el.required && (el.value === '' || el.value === undefined)) {
          hasEmpty = true
          if ( !firstEl ) firstEl = el
          el.classList.add('has-error')
        } else {
          if (el.classList.contains('has-error')) {
            el.classList.remove('has-error')
          }
        }
      }
      if ( hasEmpty ) {
        alert('Please fill all required data.')
        firstEl.focus()
        return false
      }
      if (this.$refs['postContent'].value === '' || this.$refs['postContent'].value === undefined) {
        alert('Please fill all required data.')
        return false
      }
      return true;
    }
  }
}
</script>

<style scoped>
  .career-details .has-error{
    outline: 1px solid red !important;
    z-index: 2 !important;
    background: #ffe9e9 !important;
    border-color: red !important;
  }
</style>